import {css} from '@emotion/css';

import {Breakpoints, mq, hoverAndPressInteraction} from '../../styles/js/mixins';
import {spacing} from '../../styles/js/variables';

const maxLinkWidth = '35rem';

const styles = {
  container: css`
    label: recommendedHubs;
    text-align: center;
  `,
  list: css`
    label: recommendedHubs__list;
    margin: 0 auto;

    ${mq(Breakpoints.TABLET)} {
      display: flex;
      justify-content: center;
    }
  `,
  link: css`
    label: recommendedHubs__link;
    ${hoverAndPressInteraction}
    width: 100%;
    max-width: ${maxLinkWidth};
    margin: ${spacing.XS} auto;
    box-shadow: 0px 0px 10px rgba(32, 32, 32, 0.1);

    ${mq(Breakpoints.TABLET)} {
      margin: ${spacing.XS};
    }
  `,
};

export default styles;
